namespace $.$$ {
	export class $shm_hitalama_components_drafts_preview extends $.$shm_hitalama_components_drafts_preview {
		draft_title() { return this.model().title( this.selected() ).trim() || 'Новый черновик' }
		text() { return this.model().text( this.selected() ) }
		edit_tools() { return this.model().can_change() ? super.edit_tools() : [] }
	}
}
